import { render, staticRenderFns } from "./ComunicacoesEletronicas.vue?vue&type=template&id=05f74a52&scoped=true"
import script from "./ComunicacoesEletronicas.vue?vue&type=script&lang=js"
export * from "./ComunicacoesEletronicas.vue?vue&type=script&lang=js"
import style0 from "./ComunicacoesEletronicas.vue?vue&type=style&index=0&id=05f74a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f74a52",
  null
  
)

export default component.exports